import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FiMapPin, FiPhone, FiMail, FiClock, 
  FiFacebook, FiInstagram, FiYoutube, 
  FiHeart, FiShoppingBag, FiTool, FiInfo, 
  FiMail as FiMailIcon, FiHome, FiSend, FiTrendingUp
} from 'react-icons/fi';
import { FaTelegramPlane } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'ទំព័រដើម', path: '/', icon: FiHome },
    { name: 'សម្លៀកបំពាក់', path: '/products', icon: FiShoppingBag },
    { name: 'ប្រម៉ូសិន', path: '/promotions', icon: FiTrendingUp },
    { name: 'អំពីយើង', path: '/about', icon: FiInfo },
    { name: 'ទំនាក់ទំនង', path: '/contact', icon: FiMailIcon }
  ];

  const services = [
    { name: 'សម្លៀកបំពាក់បុរស', icon: FiShoppingBag },
    { name: 'សម្លៀកបំពាក់នារី', icon: FiShoppingBag },
    
    { name: 'ធានាគុណភាព', icon: FiHeart },
    { name: 'ដឹកជញ្ជូនលឿន', icon: FiSend }
  ];

  const socialLinks = [
    { icon: FiFacebook, url: 'https://web.facebook.com/NAaCollection', label: 'Facebook', color: '#1877f2' },
    { icon: FiInstagram, url: 'https://instagram.com/naacollection', label: 'Instagram', color: '#e4405f' },
    { icon: FaTelegramPlane, url: 'https://t.me/nnick321', label: 'Telegram', color: '#0088cc' },
    { icon: FiYoutube, url: '#', label: 'YouTube', color: '#ff0000' }
  ];

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">អំពីយើង</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              NAa Collection ផ្តល់ជូននូវសម្លៀកបំពាក់បុរស និងនារី ទាន់សម័យ 
              គុណភាពខ្ពស់ ជាមួយនឹងការធានាផលិតផល និងសេវាកម្មក្រោយពេលលក់ដ៏ល្អប្រសើរ។
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 bg-gray-800 text-gray-400 hover:bg-black hover:text-white transition-colors"
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">តំណរហ័ស</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => {
                const Icon = link.icon;
                return (
                  <li key={index}>
                    <Link
                      to={link.path}
                      className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      <Icon size={14} />
                      <span>{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Services / Categories */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">ប្រភេទសម្លៀកបំពាក់</h3>
            <ul className="space-y-2">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <li key={index} className="flex items-center gap-2 text-gray-400 text-sm">
                    <Icon size={14} className="text-gray-500" />
                    <span>{service.name}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">ទំនាក់ទំនង</h3>
            <div className="space-y-3">
              <div className="flex gap-3">
                <FiMapPin className="text-gray-500 mt-1 flex-shrink-0" size={16} />
                <p className="text-gray-400 text-sm">
                  ក្បែររង្វង់មូលទុរេន<br />
                  កំពត, កម្ពុជា
                </p>
              </div>
              <div className="flex gap-3">
                <FiPhone className="text-gray-500 mt-1 flex-shrink-0" size={16} />
                <div>
                  <p className="text-gray-400 text-sm">+855 10 768 240</p>
                  <p className="text-gray-400 text-sm">+855 78 446 444</p>
                </div>
              </div>
              <div className="flex gap-3">
                <FiMail className="text-gray-500 mt-1 flex-shrink-0" size={16} />
                <p className="text-gray-400 text-sm">naacollection@gmail.com</p>
              </div>
              <div className="flex gap-3">
                <FiClock className="text-gray-500 mt-1 flex-shrink-0" size={16} />
                <div>
                  <p className="text-gray-400 text-sm">
                    <span className="font-medium text-white">ចន្ទ - អាទិត្យ:</span> ៨:០០ - ២១:០០
                  </p>
                  <p className="text-green-500 text-xs mt-1 flex items-center gap-1">
                    <span className="inline-block w-2 h-2 bg-green-500 rounded-full"></span>
                    បើករាល់ថ្ងៃ
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <div>
              <h3 className="text-white font-bold text-lg mb-2">ទទួលបានព័ត៌មានថ្មីៗ</h3>
              <p className="text-gray-400 text-sm">
                ចុះឈ្មោះទទួលបានព័ត៌មានថ្មីៗ និងការផ្តល់ជូនពិសេសពីយើង
              </p>
            </div>
            <div>
              <form className="flex" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="email"
                  placeholder="អ៊ីមែលរបស់អ្នក..."
                  className="flex-1 px-4 py-2 border border-gray-700 bg-gray-800 text-gray-300 text-sm focus:outline-none focus:border-black"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-black text-white text-sm font-medium hover:bg-gray-800 transition-colors"
                >
                  ចុះឈ្មោះ
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Opening Hours Banner */}
        <div className="mt-6 pt-4 border-t border-gray-800">
          <div className="bg-black rounded-lg p-3 text-center">
            <div className="flex items-center justify-center gap-2 flex-wrap">
              <FiClock className="text-white" size={18} />
              <span className="text-white font-medium">ម៉ោងបើកដំណើរការ:</span>
              <span className="text-white font-bold">ចន្ទ - អាទិត្យ</span>
              <span className="text-white">៨:០០ ព្រឹក - ៩:០០ យប់</span>
              <span className="bg-green-600 text-white text-xs px-2 py-1 rounded-full ml-2">
                បើករាល់ថ្ងៃ
              </span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-4 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-xs">
            © {currentYear} NAa Collection. រក្សាសិទ្ធិគ្រប់យ៉ាង។
          </p>
          <p className="text-gray-600 text-xs mt-1 flex items-center justify-center gap-1">
            Designed with <FiHeart className="text-red-500 inline" size={12} /> for Cambodian customers
            <span className="ml-2">👖 👗 👠 👜 ✨</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;